'use client';
var styles = {"article":"ToastAction-module_article__6vQAP","text":"ToastAction-module_text__L8osc","area-profile":"ToastAction-module_area-profile__CSSSG","profile":"ToastAction-module_profile__5WVe9","button-close":"ToastAction-module_button-close__B8r5L"};

export { styles as default };
